/* eslint-disable no-useless-escape */
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Tabs, Tab } from '@mui/material';

import authService from '../../services/napoleon/AuthService';
import {
  ButtonComponent, Link, Logo, Modal, Text,
} from '../../components';
import { LoginForm, RegisterForm } from './components';
import { errorMessages } from './components/RegisterForm/steps/helpers';
import {
  Container, ContainerMsg, Title, ContainerLoginForm, ErrorLogin, styles,
} from './styles';
import { handleAccessFactory } from './helpers';
import COLORS from '../../styles/Colors';
import GlobalStyles from '../../styles/GlobalStyles';
import { TINCO_WEBSITE } from '../../constants/links';
import useAuth from '../../common/hooks/useAuth';
import { companyService } from '../../services/napoleon';

const tabs = {
  login: { value: 'login', label: 'Login' },
  register: { value: 'register', label: 'Criar Conta' },
};

export default function Login() {
  const dispatch = useDispatch();
  const [valueTabs, setValueTabs] = useState(tabs.login.value);
  const handleChangeValueTabs = (event, newValue) => setValueTabs(newValue);
  const sessionExpired = useSelector((state) => state.userReducer.sessionExpired);
  const currentStep = useSelector((state) => state.registerStepReducer.currentStep);

  const { login } = useAuth((e) => handleChangeValueTabs(e, tabs.register.value));
  const access = handleAccessFactory(dispatch, authService, currentStep);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailLabelError, setEmailLabelError] = useState('');
  const [passWordLabelError, setPassWordLabelError] = useState('');
  const [emailNull, setEmailNull] = useState(false);
  const [passwordNull, setPasswordNull] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [sessionExpiredError, setSessionExpiredError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);

  async function handleAccess() {
    setLoading(true);
    setLoginError(false);
    setSessionExpiredError(false);

    const result = await access({ email, password });
    if (result.success) {
      const { companyId } = result.data.decoded.user;
      if (companyId === null) {
        setShowModal(true);
      } else {
        const response = await companyService.getCompanyById(companyId);
        const collaboratorSizeRangeId = response.data;

        if (!collaboratorSizeRangeId) {
          setShowModal(true);
        }
      }
      login(result.data.token);
      return;
    }

    setLoading(false);
    setLoginError(true);
    setEmailNull(false);
    setPasswordNull(false);
  }

  const resetValidation = () => {
    setLoginError(false);
    setSessionExpiredError(false);
    setEmailNull(false);
    setPasswordNull(false);
    setEmailLabelError('');
    setPassWordLabelError('');
  };

  const isValidEmail = () => {
    const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regexEmail.test(email);
  };

  const validateEmail = () => {
    if (email === '') {
      setEmailNull(true);
      setEmailLabelError(errorMessages.MANDATORY_FIELD);
    }

    if (!isValidEmail()) {
      setEmailNull(true);
      setPasswordNull(true);
    } else {
      setEmailNull(false);
      setEmailLabelError('');
    }
  };

  const validatePassword = () => {
    if (password === '') {
      setPassWordLabelError(errorMessages.MANDATORY_FIELD);
      setPasswordNull(true);
    } else {
      setPasswordNull(false);
      setPassWordLabelError('');
    }
  };

  const validate = () => {
    if (loading) return;

    resetValidation();
    validateEmail();
    validatePassword();

    if (emailNull || passwordNull) return;
    setLoading(true);
    handleAccess();
  };

  const verifyEnterPress = (event) => {
    if (event.keyCode === 13) {
      validate();
    }
  };

  const renderMessageError = () => {
    if (loginError) return 'Dados incorretos';
    if (sessionExpiredError) return 'Sessão expirada, realize o login novamente';
    return '';
  };

  useEffect(() => {
    if (sessionExpired) {
      setSessionExpiredError(true);
      dispatch({ type: 'RESET_USER_STATE' });
    }
  }, [sessionExpired]);

  return (
    <Container>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={7} md={8} lg={8} container>
          <ContainerMsg>
            <Link href={TINCO_WEBSITE} target="_blank">
              <Logo style={styles.logo} />
            </Link>
            <Title>Para distribuir benefícios, ou para comunicar com seus colaboradores.</Title>
            <Text variant="h3" style={styles.subTitle}>
              Nós estamos aqui para ajudar.
            </Text>
          </ContainerMsg>
        </Grid>

        <Grid item xs={12} sm={5} md={4} lg={4} container>
          <Grid item xs container direction="column" spacing={1}>
            <ContainerLoginForm>
              <Tabs
                value={valueTabs}
                onChange={handleChangeValueTabs}
                textColor="primary"
                indicatorColor="primary"
                aria-label="primary tabs example"
                centered
              >
                <Tab {...tabs.login} style={GlobalStyles.tab} />
                <Tab {...tabs.register} style={GlobalStyles.tab} />
              </Tabs>

              {valueTabs === tabs.login.value ? (
                <>
                  <LoginForm
                    valueEmail={email}
                    onChangeEmail={(event) => setEmail(event.target.value)}
                    onChangePass={(event) => setPassword(event.target.value)}
                    valuePass={password}
                    emailLabelError={emailLabelError}
                    passWordLabelError={passWordLabelError}
                    emailNull={emailNull}
                    passwordNull={passwordNull}
                    onClick={() => validate()}
                    validateEmail={(event) => {
                      validateEmail();
                      verifyEnterPress(event);
                    }}
                    validatePassword={(event) => {
                      validatePassword();
                      verifyEnterPress(event);
                    }}
                    showLoading={loading}
                    startNow={(e) => handleChangeValueTabs(e, tabs.register.value)}
                  />
                  {(loginError || sessionExpiredError) && (
                    <ErrorLogin>
                      <Text variant="label" color={COLORS.SECONDARY_LIGHT}>
                        {renderMessageError()}
                      </Text>
                    </ErrorLogin>
                  )}
                </>
              ) : (
                <RegisterForm startNow={(e) => handleChangeValueTabs(e, tabs.register.value)} />
              )}
            </ContainerLoginForm>
          </Grid>
        </Grid>
        {showModal && (
          <Modal open={showModal} onClose={() => setShowModal(false)}>
            <Text variant="h3">Bem-vindo!</Text>

            <Text mb={3}>
              Antes de continuar, finalize seu cadastro para liberar o acesso à plataforma.
            </Text>
            <ButtonComponent variant="contained" onClick={() => setShowModal(false)}>
              Fechar
            </ButtonComponent>
          </Modal>
        )}
      </Grid>
    </Container>
  );
}
